import * as Yup from "yup";

import {
    phoneRegex,
    zipRegex,
    faxRegex,
} from "./validationFunctions";



export const repContactInfoValidations = section => {
    if (section.active) {
        return Yup.object().shape({
            repRole: section.fields.repRole.validations.required.value && Yup.string()
                .required(
                    () =>
                        section.fields.repRole.validations.required.message
                ),
            discloseToOrgName: section.fields.discloseToOrgName.validations.required.value && Yup.string()
                .max(
                    section.fields.discloseToOrgName.validations.maxLength.value,
                    section.fields.discloseToOrgName.validations.maxLength.message
                )
                .required(
                    () =>
                        section.fields.discloseToOrgName.validations.required.message
                ),
            discloseToFName: section.fields.discloseToFName.validations.required.value && Yup.string().required(
                () =>
                    section.fields.discloseToFName.validations.required.message
            ),
            discloseToLName: section.fields.discloseToLName.validations.required.value && Yup.string().required(
                () =>
                    section.fields.discloseToLName.validations.required.message
            ),
            discloseToPhone: section.fields.discloseToPhone.validations.required.value && Yup.string()
                .required(
                    () =>
                        section.fields.discloseToPhone.validations.required.message
                )
                .matches(
                    phoneRegex,
                    section.fields.discloseToPhone.validations.validPhone.message
                ),
            discloseToEmail: section.fields.discloseToEmail.validations.required.value && Yup.string()
                .required(
                    () =>
                        section.fields.discloseToEmail.validations.required.message
                )
                .email(
                    section.fields.discloseToEmail.validations.validEmail.message
                )
                .max(
                    section.fields.discloseToEmail.validations.maxLength.value,
                    section.fields.discloseToEmail.validations.maxLength.message
                ),
            discloseToFax: Yup.string()
                .matches(
                    faxRegex,
                    'Fax number is not valid'
                ),
            discloseToAddressLine1: section.fields.discloseToAddressLine1.validations.required.value && Yup.string()
                .required(
                    () =>
                        section.fields.discloseToAddressLine1.validations.required.message
                )
                .max(
                    section.fields.discloseToAddressLine1.validations.maxLength
                        .value,
                    section.fields.discloseToAddressLine1.validations.maxLength
                        .message
                ),
            discloseToAddressLine2: Yup.string()

                .max(
                    section.fields.discloseToAddressLine2.validations.maxLength.value,
                    section.fields.discloseToAddressLine2.validations.maxLength
                        .message
                ),
            discloseToCity: section.fields.discloseToCity.validations.required.value && Yup.string()
                .required(
                    () =>
                        section.fields.discloseToCity.validations.required.message
                )
                .matches(/^[A-Za-z\s-]+$/, 'City must contain only letters, spaces, and dashes')
                .max(
                    section.fields.discloseToCity.validations.maxLength.value,
                    section.fields.discloseToCity.validations.maxLength.message
                ),
            discloseToState: section.fields.discloseToState.validations.required.value && Yup.string()
                .required(
                    () => 
                        section.fields.discloseToState.validations.required.message
                    
                )
                .matches(/^[A-Za-z]{2}$/, 'State must contain only letters')
                .max(
                    section.fields.discloseToState.validations.maxLength.value,
                    section.fields.discloseToState.validations.maxLength.message
                ),
            discloseToMName: Yup.string()
                .max(
                    section.fields.discloseToMName.validations.maxLength.value,
                    section.fields.discloseToMName.validations.maxLength.message
                ),
            discloseToZip: section.fields.discloseToZip.validations.required.value && Yup.string()
                .required(
                    () =>
                        section.fields.discloseToZip.validations.required.message
                )
                .matches(
                    zipRegex,
                    section.fields.discloseToZip.validations.validZipcode.message
                )
        });
    } else {
        return Yup.object().shape();
    }
};



